/** Local files live under /public/images — keep in sync with scripts/fetch-marketing-assets.mjs */

/**
 * Resolve a URL for a file in `public/`. Required when Vite `base` is not `/`
 * (e.g. deployed under a subpath); avoids 404s for `/images/...` only working at domain root.
 */
export function publicAsset(path: string): string {
  const trimmed = path.startsWith('/') ? path.slice(1) : path
  const base = import.meta.env.BASE_URL ?? '/'
  if (base === '/' || base === '') {
    return `/${trimmed}`
  }
  const root = base.endsWith('/') ? base.slice(0, -1) : base
  return `${root}/${trimmed}`
}

export const SITE_IMAGES = {
  logo: publicAsset('images/full-wordmark-gold.svg'),

  home: {
    hero: publicAsset('images/home/hero.jpg'),
    stepRulebook: publicAsset('images/home/step-rulebook.png'),
    stepInput: publicAsset('images/home/step-input.png'),
    stepEngine: publicAsset('images/home/step-engine.png'),
    stepReport: publicAsset('images/home/step-report.png'),
    band: publicAsset('images/home/band.jpg'),
  },

  contact: {
    header: publicAsset('images/contact/header.jpg'),
  },

  product: {
    /**
     * DOM order on halocompliance.com/product: hero → title → Sales img → Sales copy → …
     * Filenames are legacy; mapping matches Squarespace order.
     */
    heroAboveTitle: publicAsset('images/product/pillar-sales.png'),
    pillarSales: publicAsset('images/product/pillar-marketing.jpg'),
    pillarMarketing: publicAsset('images/product/pillar-compliance.png'),
    pillarCompliance: publicAsset('images/product/banner.png'),
  },

  team: {
    tyler: publicAsset('images/team/tyler-moore.png'),
    malcolm: publicAsset('images/team/malcolm-bertenshaw.jpg'),
    sarah: publicAsset('images/team/sarah-simms.jpg'),
    chris: publicAsset('images/team/chris-bunker.jpg'),
  },
} as const
